<template>
    <v-app id="app">

            <v-layout  class="py-lg-10 py-5">
 <v-flex lg12 xs12 class="px-10">

                    <div class="text-lg-body-1 text-h6 font-weight-black"> Tutor Evaluation Forms and Reports </div>
                    
                    <v-row class="mt-10"> 

                        <v-col cols="" lg="4" sm="4">

                                <v-card class="px-lg-0 px-7 py-10 elevation-0 card-color">

                                       <v-layout row>

                                           <v-flex lg12 xs10>

                                               <div class="font-weight-black text-center text-body-1 mt-n2 "> CLASS HANDLING </div>

                                           </v-flex>

                                           <v-flex lg4 xs4 class="mt-lg-5 mt-15">

                                               <v-img src="@/assets/images/Monitoring/perf-eval-icons/class_handling.svg" class="imagesize" contain/>

                                           </v-flex>

                                           <v-flex lg6 xs8 class="mt-lg-7 mt-12">

                                               <v-card @click="linkSend('classHandlingForm')" class="px-lg-10 px-5 py-lg-2 elevation-0 text-center text-lg-caption font-weight-black cursor-point">
                                                    FILL OUT FORMS
                                               </v-card>
                                                <v-card class="mt-2 px-lg-10 px-5 py-lg-2 elevation-0 text-center text-lg-caption font-weight-black">
                                                    VIEW REPORTS
                                               </v-card>

                                           </v-flex>
                                           

                                       </v-layout>

                                </v-card>

                        </v-col>

                        <v-col cols="" lg="4" sm="4">

                                <v-card class="px-lg-0 px-7 py-10 elevation-0 card-color">

                                       <v-layout row>

                                           <v-flex lg12 xs10>

                                               <div class="font-weight-black text-center text-body-1 mt-n2"> STUDENT SATISFACTION </div>

                                           </v-flex>

                                           <v-flex lg4 xs4 class="mt-5">

                                               <v-img src="@/assets/images/Monitoring/perf-eval-icons/student_satisfaction.svg" class="imagesize" contain/>

                                           </v-flex>

                                           <v-flex lg6 xs8 class="mt-12">

                                               <v-card @click="linkSend('studentStatReport')" class="px-lg-10 px-5 py-lg-2 elevation-0 text-center text-lg-caption font-weight-black">
                                                    VIEW REPORTS
                                               </v-card>

                                           </v-flex>
                                           

                                       </v-layout>

                                </v-card>

                        </v-col>

                       <v-col cols="" lg="4" sm="4">

                                <v-card class="px-lg-0 px-7 py-10 elevation-0 card-color">

                                       <v-layout row>

                                           <v-flex lg12 xs10>

                                               <div class="font-weight-black text-center text-body-1 mt-n2"> STUDENT RETENTION </div>

                                           </v-flex>

                                           <v-flex lg4 xs4 class="mt-5">

                                               <v-img src="@/assets/images/Monitoring/perf-eval-icons/student_retention.svg" class="imagesize" contain/>

                                           </v-flex>

                                           <v-flex lg6 xs8 class="mt-12">

                                               <v-card @click="linkSend('studentRetenReport')" class="px-lg-10 px-5 py-lg-2 elevation-0 text-center text-lg-caption font-weight-black">
                                                    VIEW REPORTS
                                               </v-card>

                                           </v-flex>
                                           

                                       </v-layout>

                                </v-card>

                        </v-col>

                        <v-col cols="" lg="4" sm="4">

                                <v-card class="px-lg-0 px-7 py-10 elevation-0 card-color">

                                       <v-layout row>

                                           <v-flex lg12 xs10>

                                               <div class="font-weight-black text-center text-body-1 mt-n2"> ATTENDANCE </div>

                                           </v-flex>

                                           <v-flex lg4 xs4 class="mt-5">

                                               <v-img src="@/assets/images/Monitoring/perf-eval-icons/attendance.svg" class="imagesize" contain/>

                                           </v-flex>

                                           <v-flex lg6 xs8 class="mt-12">

                                               <v-card @click="linkSend('attendance')" class="px-lg-10 px-5 py-lg-2 elevation-0 text-center text-lg-caption font-weight-black">
                                                    ATTENDANCE ISSUES
                                               </v-card>

                                           </v-flex>
                                           

                                       </v-layout>

                                </v-card>

                        </v-col>

                        <v-col cols="" lg="4" sm="4">

                                <v-card class="px-lg-0 px-7 py-10 elevation-0 card-color">

                                       <v-layout row>

                                           <v-flex lg12 xs10>

                                               <div class="font-weight-black text-center text-body-1 mt-n2"> MANAGER REVIEW </div>

                                           </v-flex>

                                           <v-flex lg4 xs4 class="mt-5">

                                               <v-img src="@/assets/images/Monitoring/perf-eval-icons/manager_review.svg" class="imagesize" contain/>

                                           </v-flex>

                                           <v-flex lg6 xs8 class="mt-12">

                                               <v-card @click="linkSend('managerReview')" class="px-lg-10 px-5 py-lg-2 elevation-0 text-center text-lg-caption font-weight-black">
                                                    MANAGER REVIEW FORM
                                               </v-card>

                                           </v-flex>
                                           

                                       </v-layout>

                                </v-card>

                        </v-col>

                        <v-col cols="" lg="4" sm="4">

                                <v-card class="px-lg-0 px-7 py-10 elevation-0 card-color">

                                       <v-layout row>

                                           <v-flex lg12 xs10>

                                               <div class="font-weight-black text-center text-body-1 mt-n2"> COMPLAINTS  </div>

                                           </v-flex>

                                           <v-flex  lg4 xs4 class="mt-5">

                                               <v-img src="@/assets/images/Monitoring/perf-eval-icons/complaints.svg" class="imagesize" contain/>

                                           </v-flex>

                                           <v-flex lg6 xs8 class="mt-12">

                                               <v-card @click="linkSend('complaints')" class="px-lg-10 px-5 py-lg-2 elevation-0 text-center text-lg-caption font-weight-black">
                                                    COMPLAINTS FORM
                                               </v-card>

                                           </v-flex>
                                           

                                       </v-layout>

                                </v-card>

                        </v-col>

                    </v-row>

                </v-flex>

               
            </v-layout>

    </v-app>

</template>
<script>
export default {
    name:'perfFR',
    methods:{

        linkSend(val){
            
                if(val == 'classHandlingForm'){
                 this.$router.push({name:'classHandling',params:{t_id:this.$route.params.t_id,mo:this.$route.params.mo}})
                }

                if(val == 'studentStatReport'){
                    this.$router.push({name:'ratingmonitoring'})
                }

                if(val == 'studentRetenReport'){
                    this.$router.push({name:'studentRetention'})
                }

                if(val == 'managerReview'){
                    this.$router.push({name:'managerReview'})
                }

                if(val == 'complaints'){
                    this.$router.push({name:'complaints',params:{t_id:this.$route.params.t_id,mo:this.$route.params.mo}})
                }
                
                if(val == 'attendance'){
                    this.$router.push({name:'attendanceIssue',params:{t_id:this.$route.params.t_id}})
                }


                
        },
        
    }
}
</script>
<style>
.card-color{
    background-color:#F4F4F4 !important;
}
.imagesize{
    max-height: 100px;
}
.cursor-point{
    cursor: pointer;
}
@media only screen and (max-width: 1200px) {

.imagesize{
    max-height: 80px;
}


}
</style>